var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPython48Filled = function SvgIconPython48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 23.61c1.99 0 3.6-1.61 3.6-3.6V13.6c0-1.99-1.61-3.6-3.6-3.6h-5.4c-1.99 0-3.6 1.61-3.6 3.6v2.83h6.3v1.76H13.6c-1.99 0-3.6 1.61-3.6 3.6v5.4c0 1.99 1.61 3.6 3.6 3.6h2.86V28.6c0-2.76 2.24-5 5-5h5.75l-.01.01Zm-4.71-9.32c-.49.49-1.28.49-1.77 0a1.25 1.25 0 0 1 0-1.77 1.25 1.25 0 0 1 1.77 0c.49.49.49 1.28 0 1.77Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 25.37c-1.99 0-3.6 1.61-3.6 3.6v6.43c0 1.99 1.61 3.6 3.6 3.6h5.4c1.99 0 3.6-1.61 3.6-3.6v-2.83h-6.3v-1.76h10.9c1.99 0 3.6-1.61 3.6-3.6v-5.4c0-1.99-1.61-3.6-3.6-3.6h-2.86v2.17c0 2.76-2.24 5-5 5h-5.75l.01-.01Zm4.71 9.34a1.25 1.25 0 0 1 1.77 0c.49.49.49 1.28 0 1.77s-1.28.49-1.77 0a1.25 1.25 0 0 1 0-1.77Z",
    fill: "current"
  })));
};
export default SvgIconPython48Filled;